import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { Modal, createUseStyles } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';

const useStyles = createUseStyles(styles, 'HtmlPreviewModal');

const HtmlPreviewModal = ({ isOpen, onClose, htmlContent, title }) => {
    const { t } = useWeb5Context();
    const classes = useStyles();

    const sanitizedHtml = useMemo(() => {
        return DOMPurify.sanitize(htmlContent || '');
    }, [htmlContent]);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            onConfirm={onClose}
            confirmText={t('cfm_action_close')}
            title={title || t('cfm_label_preview')}
            size="large"
        >
            <div className={classes.modalContent}>
                <div
                    className={classes.htmlPreview}
                    dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
                />
            </div>
        </Modal>
    );
};

HtmlPreviewModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    htmlContent: PropTypes.string,
    title: PropTypes.string,
};

export default memo(HtmlPreviewModal);
